if (!customElements.get('gg-brand-catalog')) {
  customElements.define('gg-brand-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.listeners = new AbortController();
      const listenerOptions = {signal: this.listeners.signal};
      const controls = [...this.querySelectorAll('[data-category-control]')];
      const panels = [...this.querySelectorAll('[data-category-panel]')];
      this.querySelectorAll('[data-progressive-products]').forEach(grid => {
        const cards = [...grid.children];
        const button = grid.parentElement.querySelector('[data-show-more]');
        if (!button || cards.length <= 8) return;
        let visible = 8;
        cards.forEach((card, index) => { card.hidden = index >= visible; });
        button.hidden = false;
        button.addEventListener('click', () => {
          const firstNewLink = cards[visible]?.querySelector('a');
          visible += 8;
          cards.forEach((card, index) => { card.hidden = index >= visible; });
          button.hidden = visible >= cards.length;
          firstNewLink?.focus({preventScroll: true});
        }, listenerOptions);
      });
      if (!controls.length || controls.length !== panels.length) return;
      const activate = (id, toggle = false) => {
        const selected = controls.find(c => c.dataset.categoryControl === id);
        const close = toggle && selected?.getAttribute('aria-expanded') === 'true';
        controls.forEach(c => c.setAttribute('aria-expanded', String(!close && c === selected)));
        panels.forEach(p => { p.hidden = close || p.id !== id; });
      };
      controls.forEach(control => {
        control.setAttribute('role', 'button');
        control.setAttribute('aria-controls', control.dataset.categoryControl);
        control.addEventListener('click', event => {
          event.preventDefault();
          activate(control.dataset.categoryControl, true);
        }, listenerOptions);
        control.addEventListener('keydown', event => {
          if (event.key === ' ') { event.preventDefault(); control.click(); }
        }, listenerOptions);
      });
      const showHash = () => {
        const panel = panels.find(p => '#' + p.id === location.hash);
        if (panel) { activate(panel.id); panel.scrollIntoView({block: 'start'}); }
      };
      activate(controls[0].dataset.categoryControl);
      showHash();
      this.onHash = showHash;
      window.addEventListener('hashchange', this.onHash);
      this.onBlockSelect = event => {
        if (!this.contains(event.target)) return;
        const panel = event.target.closest('[data-category-panel]');
        if (panel) activate(panel.id);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }
    disconnectedCallback() {
      this.listeners?.abort();
      window.removeEventListener('hashchange', this.onHash);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.ready = false;
    }
  });
}
